import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  push
} from 'react-router-redux';
import {
  Button,
  Container,
  Header,
  Icon,
  List,
  Menu,
  Modal,
  Segment
} from 'semantic-ui-react';
import {
  Link
} from 'react-router-dom';
import {
  Route
} from 'react-router-dom';
import feathersConnect from './../../../providers/feathersConnect';
import AList from '../../auto/AList';

const PAGE_RANGE = 10;

class SectoresView extends Component {

  constructor (props) {
    super(props);

    this.SectorService = this.props.feathers.service('/api/sectores');
    this.RubroService = this.props.feathers.service('/api/rubros');
  }

  componentDidMount () {

  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    let rubroSelectConfig = {
      service: this.RubroService,
      mapFunction: (rubro, index) => {
        return {
          key: index,
          text: rubro.nombre,
          value: rubro.id
        };
      }
    };

    return (
      <div>
        <AList
          pageRange={PAGE_RANGE}
          mapFunction={(sector) => ({
            id: sector.id,
            header: `${sector.nombre}`,
            description: `${sector.rubro.nombre}`
          })}
          service={this.SectorService}
          form={{
            fields: [
              ['!Nombre', 'nombre', 'input', 8],
              ['!Rubro', 'RubroId', 'asyncselect', 8, rubroSelectConfig]
            ],
            service: this.SectorService
          }} />
      </div>
    );
  }
}

export default feathersConnect(
  connect(
    SectoresView.mapStateToProps,
    SectoresView.mapDispatchToProps
  )(SectoresView)
);



// WEBPACK FOOTER //
// ./client/components/pages/misc/SectoresView.js